import { useCallback } from "react";
import { useSubstructureApi, useSubstructureInstanceMeta, } from "@plansoft-configuration-renderer/framework";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
/**
 * Get props for SubstructureInstanceMoveUpButton
 * @param options
 * @returns
 */
export function useSubstructureInstanceMoveUpButtonProps(options) {
    const { substructure } = options;
    const t = useUiTranslator();
    const { moveSubCfgObject } = useSubstructureApi();
    const { upwardPath, canMoveUpward, isSingleInstance, instancePath } = useSubstructureInstanceMeta(substructure);
    const onClick = useCallback(() => {
        if (canMoveUpward) {
            moveSubCfgObject({ path: instancePath, targetPath: upwardPath });
        }
    }, [canMoveUpward, upwardPath, instancePath, moveSubCfgObject]);
    return {
        title: t("ConfigurationRenderer:SubconfigurationInstance.moveUp", "Move up"),
        disabled: !canMoveUpward,
        hideDisabled: isSingleInstance,
        onClick,
    };
}
//# sourceMappingURL=useSubstructureInstanceMoveUpButtonProps.js.map